import { render, staticRenderFns } from "./portWarehouseChargesInfo.vue?vue&type=template&id=4217ef77&scoped=true&"
import script from "./portWarehouseChargesInfo.vue?vue&type=script&lang=js&"
export * from "./portWarehouseChargesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4217ef77",
  null
  
)

export default component.exports